import { FC, useEffect } from "react";
import { useTranslations } from "next-intl";

import PaymentItem from "./payment-item";
import { IPaymentProvider } from "@/types/apiResponse.types";
import { ShowWhen } from "@/components/common";

type Props = {
  totalAmount?: number;
  selectedMethodId: string;
  handleSelectMethod: (id: string) => void;
  providersList: IPaymentProvider[];
  isPayByBalance?: boolean;
  handleTogglePayByBalance?: () => void;
  showSelectBalance: boolean;
  isRefillBalance?: boolean;
};

export interface IPaymentMethod {
  id: number;
  icon: FC;
  title?: string;
  description?: string;
  name: string;
}

const PaymentMethods: FC<Props> = ({
  // isPayByBalance,
  // handleTogglePayByBalance,
  // showSelectBalance,
  totalAmount,
  selectedMethodId,
  handleSelectMethod,
  providersList,
  isRefillBalance = false,
}) => {
  const t = useTranslations();

  useEffect(() => {
    // Update the selected method ID if there's only one provider
    if (providersList.length === 1) {
      handleSelectMethod(providersList[0].id);
    }
  }, [providersList, handleSelectMethod]);

  // const methodsList = useMemo<IPaymentMethod[]>(
  //   () => [
  //     {
  //       id: 1,
  //       title: "pay_with_your_account_balance",
  //       name: "accountBalance",
  //       icon: WalletIcon,
  //       description: `${t("total")}: $${totalAmount}`,
  //     },
  //     // {
  //     //   id: 2,
  //     //   title: "bank_card",
  //     //   name: "bankCard",
  //     //   icon: BankCardIcon,
  //     //   description: "Visa / Mastercard",
  //     // },
  //     // {
  //     //   id: 4,
  //     //   name: "g_pay",
  //     //   icon: GoogleaPayIcon,
  //     // },
  //   ],
  //   [totalAmount],
  // );

  return (
    <div className="w-full">
      {/* <h3 className="mb-3 text-sm font-medium uppercase text-[#b2b2b2]">
        {t("choose_payment_method")}
      </h3> */}

      {/* <ShowWhen condition={showSelectBalance}>
        {methodsList.map(({ id, title, description, icon }) => {
          const Icon = icon;
          return (
            <div
              key={id}
              className={classNames(
                "flex h-[50px] cursor-pointer items-center justify-between rounded-[99px] border border-transparent p-[5px] pr-[10px]",
                {
                  "primary-border bg-[#f9f9f9]": isPayByBalance,
                  shadow: !isPayByBalance,
                },
              )}
              onClick={handleTogglePayByBalance}
            >
              <div className="flex flex-row items-center gap-[7px]">
                <span
                  className={classNames({
                    "flex h-10 w-10 items-center justify-center rounded-full":
                      !!id,
                    "bg-[#f9f9f9]": !!description && !!title && !isPayByBalance,
                    "bg-white": !!description && !!title && isPayByBalance,
                  })}
                >
                  <Icon />
                </span>
                <div className="flex flex-col">
                  <p className="text-nowrap text-xs font-medium">{title}</p>
                  <ShowWhen condition={!!description && !!title}>
                    <p className="text-nowrap text-xs font-normal text-[#7d7d7d]">
                      {description}
                    </p>
                  </ShowWhen>
                </div>
              </div>
              <CustomRadioButton
                id="balance"
                name="balance"
                primaryColor
                selected={isPayByBalance}
                onChange={() => {}}
              />
            </div>
          );
        })}
      </ShowWhen> */}
      <div className="mb-6 mt-6">
        <ShowWhen condition={!isRefillBalance}>
          <h3 className="mb-3 text-sm font-medium uppercase text-[#b2b2b2]">
            {`${t("how_you_pay_remaining")} ($${totalAmount || 0}?)`}
          </h3>
        </ShowWhen>
        <div className="grid w-full grid-cols-1 items-center gap-4">
          {providersList &&
            providersList.map((method) => (
              <PaymentItem
                key={method.id}
                isSelected={
                  selectedMethodId === method.id || providersList.length === 1
                }
                item={method}
                handleSelectMethod={handleSelectMethod}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default PaymentMethods;
